__turbopack_context__.v({
  "container": "Badge-module__AZOXXG__container",
  "default": "Badge-module__AZOXXG__default",
  "neutral": "Badge-module__AZOXXG__neutral",
  "success": "Badge-module__AZOXXG__success",
});
